import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import VenueCourtCreateEditForm from './Components/VenueCourtCreateEditForm';
import VenueCourtApi from './VenueCourtApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: VenueCourtCreateEditForm,
                getCreate: VenueCourtApi.create,
                getClone: VenueCourtApi.getOne,
                defaults: {},
                successMessage: "VenueCourt Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}